// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._34Vdm{display:-ms-flexbox;display:flex;color:#231815;-ms-flex-align:center;align-items:center}._2dKLb{width:24px;width:1.5rem;height:24px;height:1.5rem;margin-right:.75rem}._26fWa{font-size:14px;font-weight:300;line-height:23px;font-family:var(--base-font)}@media(max-width:767px){._26fWa{font-size:16px;line-height:26px}}", ""]);
// Exports
exports.locals = {
	"NAVBAR_HEIGHT": "72",
	"TABLET_WIDTH": "768",
	"DESKTOP_WIDTH": "1024",
	"WIDE_DESKTOP_WIDTH": "1440",
	"root": "_34Vdm",
	"icon": "_2dKLb",
	"content": "_26fWa"
};
module.exports = exports;
